class Sutikezeles {

    showAdatvedelem(state) {
        if (state == 'on') {

            $('.super-popup.gdpr').removeClass('condensed');
            $('.super-popup.gdpr .uzenet').addClass('hide');
            $('.super-popup.gdpr .adatvedelem').removeClass('hide');
            $('.super-popup.gdpr .butt-on').addClass('hide');
            $('.super-popup.gdpr .butt-off').removeClass('hide');

            setTimeout(function () {
                if ($('.super-popup.gdpr .adatvedelem a#cookie').length > 0) {
                    $('.super-popup.gdpr .adatvedelem').get(0).scrollTop = ($('.super-popup.gdpr .adatvedelem a#cookie').position().top - 80);
                }
            }, 200)

        } else if (state == 'off') {
            $('.super-popup.gdpr').addClass('condensed');
            $('.super-popup.gdpr .uzenet').removeClass('hide');
            $('.super-popup.gdpr .adatvedelem').get(0).scrollTop = 0;
            $('.super-popup.gdpr .adatvedelem').addClass('hide');
            $('.super-popup.gdpr .butt-on').removeClass('hide');
            $('.super-popup.gdpr .butt-off').addClass('hide');
        }

    }

    elfogadas() {

        $('.super-popup, .super-popup-2026, .super-popup-layer').remove();

        var diszt = $('html').data('disztributor');

        if (document.cookie.indexOf(diszt + "-gdpr-accepted") == -1) {
            var egyev = new Date(new Date().getTime() + (3600 * 24 * 365 * 1000));
            document.cookie = diszt + "-gdpr-accepted=" + egyev.getTime() + "; expires=" + egyev.toGMTString();
        }

        document.cookie = diszt + "-gdpr-denied=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/";

        window.location.reload();
    }

    showSettings(el) {
        if ($('.super-popup-2026 .settings').hasClass('off')) {
            $('.super-popup-2026 .settings').removeClass('off');
            $('.super-popup-2026 .uzenet').addClass('off');
            console.log($(el).data('submit-text'));
            $(el).text($(el).data('submit-text'));
        } else {

            if ($('.super-popup-2026 .settings #settingmarketing').is(':checked')) {
                this.elfogadas();
            } else {
                this.elutasitas();
            }

        }
    }

    elutasitas() {

        $('.super-popup, .super-popup-2026, .super-popup-layer').remove();

        var diszt = $('html').data('disztributor');

        if (document.cookie.indexOf(diszt + "-gdpr-denied") == -1) {
            var egyev = new Date(new Date().getTime() + (3600 * 24 * 365 * 1000));
            document.cookie = diszt + "-gdpr-denied=" + egyev.getTime() + "; expires=" + egyev.toGMTString();
        }
        document.cookie = diszt + "-gdpr-accepted=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/";

        window.location.reload();
    }

    clearAll() {
        var cookies = document.cookie.split(";");

        for (var i = 0; i < cookies.length; i++) {

            var cookie = cookies[i];
            var eqPos = cookie.indexOf("=");
            var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
            name = name.trim()
            if (name.indexOf('_g') > -1 || name.indexOf('__utm') > -1) {
                Cookies.remove(name);
                Cookies.remove(name, { path: '/' });
                Cookies.remove(name, { path: '/', domain: '.podoroele.de' });
                Cookies.remove(name, { path: '/', domain: document.domain });
            }
        }
    }

    showPopup(clearAll = false) {
        if (clearAll) {
            this.clearAll();
        }
        $('.super-popup-layer').removeClass('d-none');
        $('.super-popup-2026').removeClass('d-none');

        return false;
    }
}

export default Sutikezeles;
